import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ApplicationDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.ApplicationDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ApplicationDTO.translate = translateService;
}
this.MCPServers = [];
this.APIKeys = [];
this.Id = null;
this.AppId = null;
this.SubscriptionId = null;
this.Name = null;
this.EnableWebSearch = false;
this.EnableWebFetch = false;
this.EnableCodeInterpreter = false;
this.EnablezAppDevModelAccess = false;
this.zAppDev_ApplicationId = null;
this.zAppDev_UserEmail = null;
this.EnableDatabaseConnection = false;
this.LLM = null;
this.ConnectionString = null;
this.DB_Driver = null;
this.DB_Tables = null;
this.LLMReasoningEffort = null;
this.RuntimeURL = null;
this.LLM_SecondarySystemPrompt = null;
this.EnableHeadlessBrowser = false;
this.ApplicationDTOKey = null;
this._key = this.ApplicationDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
AppId:any;
SubscriptionId:any;
Name:any;
EnableWebSearch:any;
EnableWebFetch:any;
EnableCodeInterpreter:any;
EnablezAppDevModelAccess:any;
zAppDev_ApplicationId:any;
zAppDev_UserEmail:any;
EnableDatabaseConnection:any;
LLM:any;
ConnectionString:any;
DB_Driver:any;
DB_Tables:any;
LLMReasoningEffort:any;
RuntimeURL:any;
LLM_SecondarySystemPrompt:any;
EnableHeadlessBrowser:any;
MCPServers:any;
APIKeys:any;
private _ApplicationDTOKey:any;
get ApplicationDTOKey(): any {
    return this._ApplicationDTOKey;
  }
set ApplicationDTOKey(value: any) {
    this._ApplicationDTOKey = value;
    this._key = value;
  }
static setMCPServers = ($this, items) => {
                if (items == null) items = [];
                if ($this.MCPServers == null) $this.MCPServers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MCPServers.length > 0) {
                    Domain.ApplicationDTO.removeMCPServers($this, $this.MCPServers[0]);
                }

                Domain.ApplicationDTO.addManyMCPServers($this, copyItems);
            }
static addManyMCPServers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ApplicationDTO.addMCPServers($this, items[i]);
                }
            }
static addMCPServers = ($this, item) => {
                if ($this.MCPServers == null) $this.MCPServers = [];
                if (item == null || $this.MCPServers.indexOf(item) > -1) return;
                $this.MCPServers.push(item);
}
static addRangeMCPServers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ApplicationDTO.addMCPServers($this, item));
            }
static removeMCPServers = ($this, item) => {
                if ($this == null || $this.MCPServers == null || $this.MCPServers.indexOf(item) === -1) return;
                var _index = $this.MCPServers.indexOf(item);
                $this.MCPServers.splice(_index, 1);
}
static clearMCPServers = ($this) => { $this.MCPServers = null; }
static setAPIKeys = ($this, items) => {
                if (items == null) items = [];
                if ($this.APIKeys == null) $this.APIKeys = [];

                const copyItems = Common.cloneObject(items);

                while ($this.APIKeys.length > 0) {
                    Domain.ApplicationDTO.removeAPIKeys($this, $this.APIKeys[0]);
                }

                Domain.ApplicationDTO.addManyAPIKeys($this, copyItems);
            }
static addManyAPIKeys = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ApplicationDTO.addAPIKeys($this, items[i]);
                }
            }
static addAPIKeys = ($this, item) => {
                if ($this.APIKeys == null) $this.APIKeys = [];
                if (item == null || $this.APIKeys.indexOf(item) > -1) return;
                $this.APIKeys.push(item);
}
static addRangeAPIKeys = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ApplicationDTO.addAPIKeys($this, item));
            }
static removeAPIKeys = ($this, item) => {
                if ($this == null || $this.APIKeys == null || $this.APIKeys.indexOf(item) === -1) return;
                var _index = $this.APIKeys.indexOf(item);
                $this.APIKeys.splice(_index, 1);
}
static clearAPIKeys = ($this) => { $this.APIKeys = null; }

static ToDTO(app: any): any{let dto = new Domain.ApplicationDTO();
dto.Id = app?.Id;
dto.Name = app?.Name;
dto.EnableCodeInterpreter = app?.EnableCodeInterpeter;
dto.EnableDatabaseConnection = app?.EnableDatabaseConnection;
if (app?.EnableDatabaseConnection) {dto.DB_Driver = app?.DatabaseConnectionInfo?.DriverName;dto.ConnectionString = app?.DatabaseConnectionInfo?.ConnectionString;dto.DB_Tables = app?.DatabaseConnectionInfo?.TablesWithAccess;}
dto.EnableWebSearch = app?.EnableWebSearch;
dto.EnableWebFetch = app?.EnableWebFetch;
dto.EnableHeadlessBrowser = app?.EnableHeadlessBrowser;
dto.EnablezAppDevModelAccess = app?.EnablezAppDevModelAccess;
dto.RuntimeURL = app?.RuntimeURL;
if (app?.EnablezAppDevModelAccess) {dto.zAppDev_UserEmail = app?.zAppDev_UserEmail;dto.zAppDev_ApplicationId = app?.zAppDev_ApplicationId;}
dto.LLM = app?.LLM;
dto.LLMReasoningEffort = app?.LLMReasoningEffort;
dto.LLM_SecondarySystemPrompt = app?.LLM_SecondarySystemPrompt;
for (let _imcp = 0; _imcp < (app?.MCPs == null ? 0 : app?.MCPs.length); _imcp++) {let mcp = app?.MCPs[_imcp];dto?.MCPServers?.add(Domain.MCPServerDTO.ToAgentDTO(mcp));}
for (let _iapiKey = 0; _iapiKey < (app?.Keys == null ? 0 : app?.Keys.length); _iapiKey++) {let apiKey = app?.Keys[_iapiKey];dto?.APIKeys?.add(Domain.APIKeyDTO.ToDTO(apiKey));}
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ApplicationDTOKey == null || $this.ApplicationDTOKey == 0;
            }


}